/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
/*!*****************************************************************!*\
  !*** ./resources/js/modules/snippets/product-description-qf.js ***!
  \*****************************************************************/
var read_more = document.querySelectorAll(".product-description-container[read-more-qf]");
read_more.forEach(function (el) {
  var read_more_control = el.querySelector("p.read-more");
  var excerpt = el.querySelector("span.excerpt");
  var full = el.querySelector("span.full");
  window.log("R", read_more_control, "E", excerpt, "F", full);
  read_more_control.addEventListener('click', function () {
    if (el.classList.contains('active')) {
      el.classList.remove("active");
      read_more_control.innerHTML = "Read more";
    } else {
      el.classList.add("active");
      read_more_control.innerHTML = "Read less";
    }
  });
});
/******/ })()
;